import Vue from 'vue'
import { LoaderHelper } from '@/shared/services/loader-helper'
import { Injector } from '@/config/dependency-injection'
import { MetaService } from '@/shared/services/meta-service'

export abstract class BaseComponent extends Vue {
  protected loaderHelper: LoaderHelper = Injector.get(LoaderHelper)
  protected metaService: MetaService = Injector.get(MetaService)
}
